import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Grid, Row, Col, Image } from 'react-bootstrap';
import './home.css';
import Experiences from './home_experiences';

class Home extends Component {
    render() {
        return(
            <div>
                <Image src={require('./assets/header.jpg')} className="home-header-image" />
                <Grid>
                    <Row className="show-grid text-center">
                        <Col xs={12} sm={4} className="person-wrapper">
                            <Link to="/KaomojiMixer">
                                <Image src={require('./assets/KaomojiMixer.png')} circle className="profile-pic" />
                            </Link>
                            <h3>Android App</h3>
                        </Col>
                        <Col xs={12} sm={4} className="person-wrapper">
                            <Link to="/HootsuiteLogo">
                                <Image src={require('./assets/FlappingOwl.png')} circle className="profile-pic" />
                            </Link>
                            <h3>Animated HTML CSS Logo</h3>
                        </Col>
                    </Row>
                    <Experiences />
                </Grid>
                <Image src={require('./assets/footer.png')} className="home-footer-image" />
            </div>
        );
    }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/home.js